import React, { useContext } from "react";
import { GlobalContext } from "../context/GlobalState";
export const IncomeExpenses = () => {
  const { transaction } = useContext(GlobalContext);
  const amount = transaction.map((transactions) => transactions.amount);

  const Expense = amount
    .filter((items) => items < 0)
    .reduce((acc, item) => (acc += item), 0);

  const Income = amount
    .filter((items) => items >= 0)
    .reduce((acc, item) => (acc += item), 0);

  return (
    <div className="inc-exp-container">
      <div>
        <h4>Income</h4>
        <p id="money-plus" className="money plus">
          Rs {Income}
        </p>
      </div>

      <div>
        <h4>Expenses</h4>
        <p id="money-minus" className="money minus">
          Rs {Math.abs(Expense)}
        </p>
      </div>
    </div>
  );
};
export default IncomeExpenses;
